import { useRouteError } from "react-router-dom";
import { TemplateKazaarPage } from "@/pages/TemplateKazaarPage";
import { SimplePage } from "@/pages/TemplateKazaarPage/SimplePage";

export const RootErrorBoundary = () => {
  const error = useRouteError();

  console.error(error);

  return (
    <TemplateKazaarPage>
      <SimplePage state="error" />
    </TemplateKazaarPage>
  );
};
